import { Flex } from '@chakra-ui/react';
import { ColDef } from 'ag-grid-community';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { SingleValueSelect } from '../../components/cellComponents/SingleValueSelect';
import { UPLOAD_TABLE_ROLES } from '../roles';

type ColDefs = Array<ColDef>;
export const uploadTableColDefs: ColDefs = [
  {
    headerName: 'Name',
    field: 'name',
    width: 200,
    editable: false,
    sortable: true,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%" justifyContent="flex-start">
        <TextBodyMedium>{params.value}</TextBodyMedium>
      </Flex>
    ),
    filter: 'agSetColumnFilter',
    filterParams: {
      values: UPLOAD_TABLE_ROLES.map((role) => role.name),
      suppressSorting: true,
    },
  },
  {
    headerName: 'Individual Insights',
    field: 'individualInsights',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToUploadInsightsCustomTagConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Objective Level Insights',
    field: 'objectiveLevelInsights',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToUploadInsightsCustomTagConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  // COMMENTING OUT BULK UPLOAD FOR NOW AS IT'S NOT IMPLEMENTED
  // {
  //   headerName: 'Bulk Upload',
  //   field: 'bulkUpload',
  //   flex: 1,
  //   cellRenderer: (params) => {
  //     return (
  //       <Flex alignItems={'center'} w="100%" h="100%">
  //         <MultiValueSelect tableType="rolesToUploadInsightsCustomTagConfig" {...params} />
  //       </Flex>
  //     );
  //   },
  //   suppressHeaderMenuButton: true
  // },
  {
    headerName: 'Custom Tags',
    field: 'customTags',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToUploadInsightsCustomTagConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
];
